export default import.meta.ROLLDOWN_FILE_URL_Mi_cqKGC6myK5zNnDLjCMA